import { Routes } from '@angular/router';
import { ApplicationGuard } from './modules/usermgmt/guards/application.guard';
import { CanDeactivateGuard } from './modules/usermgmt/guards/can-deactivate.guard';



export const routes: Routes = [
    { path: '', redirectTo: 'landing', pathMatch: 'full' }, // Default route
    {
        path: 'landing',
        canActivate: [ApplicationGuard],
        data: { resource: 'Home' },
        loadComponent: () => import('./components/landing/landing.component').then((m) => m.LandingComponent),
    },
    // ===== BEGIN Export-DWG feature route =====
    {
        path: 'export-dwg',
        canActivate: [ApplicationGuard],
        data: { resource: 'Cad', mode: 'export-dwg' },
        loadComponent: () => import('./components/landing/landing.component').then((m) => m.LandingComponent),
    },
    // ===== END Export-DWG feature route =====
    {
        path: 'zone-rules',
        canActivate: [ApplicationGuard],
        data: { resource: 'Home' },
        loadComponent: () => import('./components/zone-rules/zone-rules.component').then((m) => m.ZoneRulesComponent),
    },
    {
        path: 'stationInfo',
        canActivate: [ApplicationGuard],
        canDeactivate: [CanDeactivateGuard],
        data: {
            resource: 'Home',
            preload: true
        },
        loadComponent: () =>
            import('./stationData/station-info/station-info.component')
                .then(m => m.StationInfoComponent),
    },
    {
        path: 'versions',
        canActivate: [ApplicationGuard],
        data: { resource: 'Home' },
        loadComponent: () => import('./components/archived-versions/archived-versions.component').then((m) => m.ArchivedVersionsComponent),

    },
    {
        path: 'addStation',
        canActivate: [ApplicationGuard],
        data: { resource: 'Home' },
        loadComponent: () => import('./components/survey-stepper/survey-stepper.component').then((m) => m.SurveyStepperComponent),
    },
    // ===== BEGIN Export-DWG feature route (PIM stepper) =====
    // {
    //     path: 'export-dwg/addStation',
    //     canActivate: [ApplicationGuard],
    //     // pimMode is read by ExportDwgStepperComponent,
    //     // For every future mode - add a route here
    //     data: { resource: 'Home', pimMode: 'cad' },
    //     loadComponent: () => import('./components/export-dwg/export-dwg-stepper/export-dwg-stepper.component').then((m) => m.ExportDwgStepperComponent),
    // },
    // ===== END Export-DWG feature route =====
    {
        path: 'access-denied',
        loadComponent: () =>
            import('./pages/no-application-access/no-application-access.component').then(
                (mod) => mod.NoApplicationAccessComponent
            ),
    },
    {
        path: 'landing/launch',
        loadComponent: () => import('./components/landing/landing.component').then((m) => m.LandingComponent),
    },
    {
        path: 'usermgmt',
        canActivate: [ApplicationGuard],
        data: { resource: 'User Management' },
        loadChildren: () =>
            import('usermgmt').then((m) => m.userMgmtRoutes)
    },
    // {
    //     path: 'pdf-layout-diff',
    //     canActivate: [ApplicationGuard],
    //     data: { resource: 'Home' },
    //     loadComponent: () => import('./pdf-layout-diff/pdf-layout-diff.component').then((m) => m.PdfLayoutDiffComponent),
    // },
    {
        path: 'major-change-access',
        canActivate: [ApplicationGuard],
        data: { resource: 'Home' },
        loadComponent: () => import('./components/major-change-access/major-change-access.component').then((m) => m.MajorChangeAccessComponent),
    },
    { path: '**', redirectTo: 'landing' },

];
